export function formatTodaysDate() {
  const today = new Date();
  const todayUTC = new Date(
    Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  );
  return todayUTC.toISOString().replace(".000", "");
}
